// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"beb8f6a8","453":"30d17dc1","455":"673304fb"}[chunkId] + ".chunk.js";
};